export enum ProjShareTabType {
    Link = 1,
    Mail = 2
}